import React from "react";
import { Link } from "react-router-dom";
const CTA =()=>{
    return(
        <div className="cta">
            <Link to="/contact">
                <button type="button">Get Started</button>
            </Link>
        </div>
    )
}
export default CTA;